<app-hourglass *ngIf="!loaded"></app-hourglass>
<div *ngIf="loaded" class="full-height">
    <div *ngIf="alertDetails" class="cmn-flex column full-height full-width">
        <div class="cmn-flex row full-width dialog-header">
            <h2 mat-dialog-title>Message Information</h2>
            <mat-slide-toggle [(ngModel)]="pauseRefresh" id="pause-refresh-toggle" aria-hidden="false" aria-label="Active" color="primary">
                Pause Auto-refresh
            </mat-slide-toggle>
            <mat-slide-toggle [(ngModel)]="expandAll" id="expand-all-toggle" aria-hidden="false" aria-label="Active" color="primary">
                Expand All
            </mat-slide-toggle>
            <button [mat-dialog-close] aria-label="Close message information" class="close-button" id="closeBtn" mat-icon-button>
                <mat-icon id="closeAlertInfo">close</mat-icon>
            </button>
        </div>
        <!-- Alert Recipient Summary table -->
        <div class="cmn-flex space-between full-height full-width">
            <div class="cmn-flex column summary-width overflow-auto">
                <div *ngIf="alertDetails.escalations.length > 0" class="cmn-flex column" id="summary-card">
                    <mat-accordion *ngFor="let escalation of alertDetails.escalations; let escalationIdx = index"
                                   class="mat-accordion escalation">
                        <mat-expansion-panel [expanded]="expand(escalationIdx)" hideToggle>
                            <mat-expansion-panel-header class="spaced-top-lg spaced-bottom-lg">
                                <mat-panel-title>
                                    <mat-icon *ngIf="!escalation.processing" class="processing-icon done">done_outline</mat-icon>
                                    <mat-icon *ngIf="escalation.processing" class="processing-icon spin">hourglass_empty</mat-icon>
                                    <span class="spaced-top-sm">{{escalation.name}}</span>
                                </mat-panel-title>
                                <span *ngIf="alertDetails.responseRequired && escalation.groups.length > 1"
                                      class="acknowledgements" id="acknowledgements{{escalationIdx}}">
                                    {{escalation.acceptedCount}}
                                    <mat-icon class="thumb-up">thumb_up</mat-icon>
                                    {{escalation.declinedCount}}
                                    <mat-icon class="thumb-down">thumb_down</mat-icon>
                                    of {{escalation.recipientCount}}
                                </span>
                            </mat-expansion-panel-header>

                            <mat-accordion *ngFor="let group of escalation.groups; let groupIdx = index"
                                           class="mat-accordion escalation-group">
                                <mat-expansion-panel #groupPanel="matExpansionPanel" id="recipient-card-group-{{(group.recipients || group.groups)[0].group_id}}" [expanded]="expand(groupIdx)" hideToggle>
                                    <mat-expansion-panel-header [ngClass]="'header-expanded-' + groupPanel.expanded"
                                                                class="full-width spaced-top-lg spaced-bottom-lg">
                                        <mat-panel-title class="cmn-flex row align-start">
                                            <span [ngClass]="groupPanel.expanded ? 'padded-top' : ''"
                                                  class="padded-right align-self-center">
                                                <mat-icon *ngIf="!group.processing && !isUnknownRecipientsGroup(group.name)" class="processing-icon done">done_outline</mat-icon>
                                                <mat-icon *ngIf="group.processing" class="processing-icon spin">hourglass_empty</mat-icon>
                                                <mat-icon *ngIf="isUnknownRecipientsGroup(group.name)">warning</mat-icon>
                                            </span>
                                            <span
                                                [ngClass]="'text-expanded-' + groupPanel.expanded">{{group.name}}</span>
                                        </mat-panel-title>
                                        <span *ngIf="alertDetails.responseRequired" class="acknowledgements">
                                            {{group.acceptedCount}}
                                            <mat-icon class="thumb-up">thumb_up</mat-icon>
                                            {{group.declinedCount}}
                                            <mat-icon class="thumb-down">thumb_down</mat-icon>
                                            of {{group.recipientCount}}
                                        </span>
                                    </mat-expansion-panel-header>

                                    <!-- Sub Group Here -->
                                    <mat-accordion *ngFor="let subGroup of group.groups; let subGroupIndex = index"
                                                   class="mat-accordion sub-group">
                                        <mat-expansion-panel #subgroupPanel="matExpansionPanel" id="recipient-card-group-{{subGroup.recipients[0].group_id}}"
                                                             [expanded]="expand(subGroupIndex)" hideToggle>
                                            <mat-expansion-panel-header
                                                [ngClass]="'header-expanded-' + subgroupPanel.expanded"
                                                class="full-width spaced-top-lg spaced-bottom-lg">
                                                <mat-panel-title
                                                    class="cmn-flex row align-start">
                                                    <span [ngClass]="subgroupPanel.expanded ? 'padded-top' : ''"
                                                          class="padded-right">
                                                        <mat-icon *ngIf="!subGroup.processing" class="processing-icon done">done_outline</mat-icon>
                                                        <mat-icon *ngIf="subGroup.processing" class="processing-icon spin">hourglass_empty</mat-icon>
                                                    </span>
                                                    <span
                                                        [ngClass]="'text-expanded-' + subgroupPanel.expanded">{{subGroup.name}}</span>
                                                </mat-panel-title>
                                                <span *ngIf="isRequired(subGroup)">
                                                    {{subGroup.acceptedCount}}
                                                    <mat-icon class="thumb-up small-thumb">thumb_up</mat-icon>
                                                    {{subGroup.declinedCount}}
                                                    <mat-icon class="thumb-down small-thumb">thumb_down</mat-icon>
                                                    of {{subGroup.recipientCount}}
                                                </span>
                                            </mat-expansion-panel-header>

                                            <ng-container
                                                *ngTemplateOutlet="recipientSummary; context: {groupId: subGroup.id, recipients: subGroup.recipients}">
                                            </ng-container>
                                        </mat-expansion-panel>
                                    </mat-accordion>

                                    <!-- Recipients Here -->
                                    <ng-container
                                        *ngTemplateOutlet="recipientSummary; context: {groupId: group.id, recipients: group.recipients}">
                                    </ng-container>
                                </mat-expansion-panel>
                            </mat-accordion>
                        </mat-expansion-panel>
                    </mat-accordion>
                </div>
                <div *ngIf="!alertDetails.escalations.length > 0">
                    <mat-card>
                        <mat-card-title>Recipients</mat-card-title>
                        <mat-card-subtitle>There was an error locating the recipients for this message</mat-card-subtitle>
                    </mat-card>
                </div>
            </div>
            <div class="status-not-flex">
                <div class="cmn-flex column cmn-border cmn-rounded padding full-width overflow-auto" id="statusTable">
                    <mat-card> <!--         Recipient Details Datatable-->
                        <div *ngIf="recipientSelected">
                            <div *ngIf="isRecipientAddressNull(selectedRecipient.address)">
                                <h6>Status Details</h6>
                            </div>
                            <div *ngIf="!isRecipientAddressNull(selectedRecipient.address)">
                                <h6>{{getRecipientName(selectedRecipient, true)}} Status Details</h6>
                            </div>
                            <ngx-datatable
                                [columnMode]="'force'"
                                [columns]="statusColumns"
                                [footerHeight]="0"
                                [headerHeight]="25"
                                [rowHeight]="25"
                                [rows]="alertStatuses"
                                [sorts]="statusSort"
                                class="material cmn-style striped dividers-vertical"
                                id="alertStatus"
                                [reorderable]="false">
                            </ngx-datatable>
                        </div>
                        <div class="full-width spaced-top-lg">
                            <h6>Message:</h6>
                            <mat-card>
                                <textarea #inputTarget cdkAutosizeMinRows="5" cdkTextareaAutosize
                                          class="padded-bottom spaced-bottom full-width" id="message" matInput
                                          readonly value="{{ messagePreview.message }}">
                                </textarea>
                                <div class="spaced-top-lg">
                                    <button (click)="copy(messagePreview.message )" [ngxClipboard]="inputTarget"
                                            class="mr10 action-button" color="primary" id="copyBtn" mat-raised-button>
                                        copy
                                    </button>
                                    <button (click)="replyBack(this.alertId, 'reply')" [mat-dialog-close]
                                            [ngxClipboard]="inputTarget" class="mr10 action-button"
                                            color="primary" id="replyBtn" mat-raised-button>
                                        reply
                                    </button>
                                    <button (click)="replyBack(this.alertId, 'forward')" [mat-dialog-close]
                                            [ngxClipboard]="inputTarget" class="mr10 action-button"
                                            color="primary" id="forwardBtn" mat-raised-button>
                                        forward
                                    </button>
                                </div>
                            </mat-card>
                        </div>
                    </mat-card>
                </div>
            </div>
        </div>
        <!-- right div end-->
    </div>

    <ng-template #recipientSummary let-groupId="groupId" let-recipients="recipients">
        <mat-card (click)="onSelectRecipient($event, recipient.id)" *ngFor="let recipient of recipients; let i = index"
                  [ngClass]="{'selected' : recipient.id === selectedRecipient.id}" class="recipient-card" [class.error]="isError(recipient)"
                  id="recipient-card-{{getRecipientEntityId(recipient)}}">
            <mat-card-content class="mat-card-content">
                <span class="cmn-flex align-center space-between">
                    <span class="cmn-flex">
                        <span class="cmn-flex spaced-right flex-10">
                            <mat-icon *ngIf="!recipient.processing && !isError(recipient)"
                                      class="processing-icon done" matTooltip="Done Processing Escalation">done_outline</mat-icon>
                            <mat-icon *ngIf="recipient.processing" class="processing-icon spin" matTooltip="Processing Escalation">
                                hourglass_empty</mat-icon>
                            <mat-icon *ngIf="isError(recipient)" class="processing-icon">error_outline</mat-icon>
                            <mat-icon *ngIf="sentSMS(recipient)" aria-hidden="false" aria-label="SMS Text" class="type-icon"
                                      matTooltip="SMS Message">perm_phone_msg</mat-icon>
                            <mat-icon *ngIf="sentEMail(recipient)" aria-hidden="false" aria-label="EMail" class="type-icon"
                                      matTooltip="E-Mail Message">email</mat-icon>
                            <mat-icon *ngIf="sentChat(recipient)" aria-hidden="false" aria-label="Chat" class="type-icon"
                                      matTooltip="Chat Message">message</mat-icon>
                            <mat-icon *ngIf="sentTeams(recipient)" aria-hidden="false" aria-label="Teams" class="type-icon"
                                      matTooltip="Teams Message">message</mat-icon>
                        </span>
                        <span *ngIf="recipient.individualName" class="namespan recipient_name individual_name">
                            {{recipient.individualName}}
                        </span>
                        <span *ngIf="!recipient.individualName && recipient.channel_name" class="namespan recipient_name device_name">
                            {{recipient.channel_name}}
                        </span>
                        <span *ngIf="!recipient.individualName && !recipient.channel_name" class="namespan recipient_name phone_number">
                            SMS DEVICE
                        </span>
                    </span>
                    <span class="align-self-end">
                        <mat-icon *ngIf="hasAccepted(recipient)" class="thumb-up">thumb_up</mat-icon>
                        <button (click)="accept(recipient)" *ngIf="acceptButtonCheck(recipient)"
                                [disabled]="!recipient.processing" aria-label="Accept" class="thumb-inactive thumb-up" mat-icon-button><mat-icon>thumb_up</mat-icon></button>
                        <mat-icon *ngIf="hasDeclined(recipient)" class="thumb-down">thumb_down</mat-icon>
                        <button (click)="decline(recipient)" *ngIf="declineButtonCheck(recipient)"
                                [disabled]="!recipient.processing" aria-label="Decline" class="thumb-inactive thumb-down" mat-icon-button><mat-icon>thumb_down</mat-icon></button>
                    </span>
                </span>

                <span
                    *ngIf="!recipient.individualName && !recipient.channel_name && !isRecipientAddressNull(recipient.address)"
                    class="namespan phone-number">
                    {{recipient.address}}
                </span>
                <br/>
                <span>
                    {{recipient.latest_status}}
                </span>
            </mat-card-content>
        </mat-card>
    </ng-template>
</div>
<!-- 13 -->
